var map = {
	"./CanvasClear": 60,
	"./CanvasClear.js": 60,
	"./CanvasMove": 61,
	"./CanvasMove.js": 61,
	"./CommandAbstract": 25,
	"./CommandAbstract.js": 25,
	"./ComponentDelete": 62,
	"./ComponentDelete.js": 62,
	"./ComponentDrag": 63,
	"./ComponentDrag.js": 63,
	"./ComponentEnter": 64,
	"./ComponentEnter.js": 64,
	"./ComponentExit": 65,
	"./ComponentExit.js": 65,
	"./ComponentNext": 66,
	"./ComponentNext.js": 66,
	"./ComponentPrev": 67,
	"./ComponentPrev.js": 67,
	"./ComponentStyleClear": 68,
	"./ComponentStyleClear.js": 68,
	"./CopyComponent": 69,
	"./CopyComponent.js": 69,
	"./DeleteComponent": 70,
	"./DeleteComponent.js": 70,
	"./ExportTemplate": 71,
	"./ExportTemplate.js": 71,
	"./Fullscreen": 72,
	"./Fullscreen.js": 72,
	"./MoveComponent": 73,
	"./MoveComponent.js": 73,
	"./OpenAssets": 74,
	"./OpenAssets.js": 74,
	"./OpenBlocks": 75,
	"./OpenBlocks.js": 75,
	"./OpenLayers": 76,
	"./OpenLayers.js": 76,
	"./OpenStyleManager": 77,
	"./OpenStyleManager.js": 77,
	"./OpenTraitManager": 78,
	"./OpenTraitManager.js": 78,
	"./PasteComponent": 79,
	"./PasteComponent.js": 79,
	"./Preview": 80,
	"./Preview.js": 80,
	"./Resize": 81,
	"./Resize.js": 81,
	"./SelectComponent": 17,
	"./SelectComponent.js": 17,
	"./SelectPosition": 26,
	"./SelectPosition.js": 26,
	"./ShowOffset": 82,
	"./ShowOffset.js": 82,
	"./SwitchVisibility": 83,
	"./SwitchVisibility.js": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;